import axios from '../../services/api'
import router from '../../router/index'

const state = {
  user: {},
  token: ''
}

const mutations = {
  SET_USER: (state, value) => {
    console.trace()
    console.log('Inside SET_USER', value)
    state.user = value
  },
  SET_TOKEN: (state, value) => {
    console.log('Inside SET_TOKEN', value)
    state.token = value
  }
}

const getters = {
  GET_USER: (state) => state.user,
  GET_TOKEN: (state) => state.token
}

const actions = {
  async HANDLE_LOGIN (app, payload) {
    console.log(app, payload, axios)
    const responseLogin = await axios.post('/user/login', payload)
    const token = responseLogin.data.token
    const user = responseLogin.data.user
    app.commit('SET_USER', user)
    app.commit('SET_TOKEN', token)
    localStorage.setItem('token', token)

    router.push('/dashboard/event')
    console.log('Inside HANDLE_LOGIN', responseLogin)
  },
  async GET_USER (app, token) {
    try {
      console.log('Inside GET_USER - app, token, axios ', app, token, axios)
      const whoamiResponse = await axios.get('user/whoami')
      // eslint-disable-next-line no-debugger
      console.log('Inside GET_USER - whoamiResponse', whoamiResponse.data.user)
      const user = whoamiResponse.data.user
      app.commit('SET_USER', user)
      return user
    } catch (error) {
      console.log('window.location.path', window.location)
      app.commit('SET_USER', {})
      app.commit('SET_TOKEN', '')
      // eslint-disable-next-line no-debugger
      console.log('Inside GET_USER - error', error, error.code, error.message)
      // if (typeof window !== 'undefined' && window.location && window.location.pathname !== '/login' && error.response.status === 401) {
      //  window.location.pathname = '/login'
      // }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
